module.exports = "a {\n  cursor: pointer;\n}\n\n.thSort {\n\tcursor: pointer;\n}\n\n.thSort:after {\n    content: ' \\25BC\\25B2';\n    display:inline;\n}\n"